



















import { Vue, Component, Prop } from 'vue-property-decorator';
import postCom from '@/components/CreatePostComponent.vue';
import moment from 'moment';
import HomePostView from '@/components/HomePostView.vue';
import * as firebase from 'firebase/app';
import User from '@/model/User';
import RoleType from '@/userManagement/RoleType';
import FirebaseUtil from '@/model/FirebaseUtil';
import { COLLECTION_ORGANIZATIONS } from '@/model/AppConstants';

@Component({
  components: {
    HomePostView,
    postCom,
  },
})
export default class PostView extends Vue {
  time = new Date();

  posts = [];

  tabs = null;

  icon = true;

  showComments = []as any;

  editedIndex = -1;

  items = [{ title: 'Delete Post' }];

  mounted() {
    this.$store.dispatch('bindOrgPublicPosts', this.refMap(this.org.id));

    // if (this.isMember()) {
    //   this.$store.dispatch('bindOrgPosts', this.refMap(this.org.id));
    // } else {
    //   this.$store.dispatch('bindOrgPublicPosts', this.refMap(this.org.id));
    // }
  }
  // eslint-disable-next-line
  refMap(id: any) {
    return FirebaseUtil.ObjectToRef(COLLECTION_ORGANIZATIONS, id);
  }

  get org() {
    return this.$store.state.orgObj;
  }

  deletePost = (id: any) => {
    this.$store.dispatch('removeFromCollection', {
      collection: 'posts',
      payload: id,
    });
  };

  get viewPostPop() {
    if (this.modCheck) {
      return true;
    }
    return !!this.org.members
      .some((m: any) => m.id === this.currentUser.uid && m
        .status.code === 'approved' && m.role.roleType.code === 'faculty');
  }

  get modCheck() {
    return (this.org.moderator.uid === this.currentUser.uid);
  }

  isMember(): any {
    const memberObj = this.org.members.find((member: any) => member
      .id === this.currentUser.uid);
    return memberObj;
  }

  get orgPosts() {
    return this.$store.state.OrgPosts;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  get Followers() {
    return this.$store.state.orgFollowers;
  }

  get Members() {
    return this.$store.state.orgMembers;
  }

  formatTime = (time: any) => {
    const date = new Date(time.seconds * 1000);
    return moment(date).fromNow();
    // return `${date.getHours()}:${date.getMinutes()}`;
  };

  viewComment(post: any) {
    if (post.comments.length) {
      this.showComments.push(post.id);
    }
  }

  hideComment(id: any) {
    const index = this.showComments.findIndex((cmtid: any) => cmtid === id);
    this.showComments.splice(index, 1);
  }
}
